import { render, staticRenderFns } from "./Help.svg.vue?vue&type=template&id=3419a1f0"
import script from "./Help.svg.vue?vue&type=script&lang=ts"
export * from "./Help.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3419a1f0')) {
      api.createRecord('3419a1f0', component.options)
    } else {
      api.reload('3419a1f0', component.options)
    }
    module.hot.accept("./Help.svg.vue?vue&type=template&id=3419a1f0", function () {
      api.rerender('3419a1f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/common/Help.svg.vue"
export default component.exports